module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/shop-b0ac2a3723ccbf7bd9c16d9a89c468d1.svg";